import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { useDispatch, useSelector } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { pushNotification } from "utils/notifications";
import DongLaiApi from "service/dongLaiApi";
import { formatNumber2 } from "utils/currencyFormat";

export const ModalPhiHangKy = (props) => {
  const init = {
    SoTien: 0,
    TenPhiKhac: "",
  };
  const [dataChiTiet, setDataChiTiet] = useState([]);
  console.log(props, "props");
  useEffect(() => {
    DongLaiApi.chiTietPhiHangKy(
      props.chovayId,
      props.paidId,
      props.typeChoVay
    ).then((response) => {
      setDataChiTiet(response.data);
    });
  }, []);
  console.log(dataChiTiet, "chi tiết kkkkkkkkkkkkkkkkkkkkkkk");

  const listItem = () => {
    return (
      dataChiTiet != null &&
      dataChiTiet.map((item, index) => {
        return (
          <tr>
            <td>{index + 1}</td>
            <td>{item.TenPhiKhac}</td>
            <td className="text-right">{formatNumber2(item.SoTien)}</td>
          </tr>
        );
      })
    );
  };
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size border-modalNew"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="fas fa-funnel-dollar"></i>
          </span>{" "}
          Chi tiết phí hàng kỳ
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse5612"
                class="card-header border-info"
                href="#collapse5612"
                aria-expanded="true"
                aria-controls="collapse5612"
              >
                <a class="card-title lead info collapsed" href={() => false}>
                  <h3>Chi tiết phí hàng kỳ</h3>
                </a>
              </div>
              <div
                id="collapse5612"
                aria-labelledby="headingCollapse5612"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="table-responsive table-2">
                      <table class="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>STT</th>
                            <th>Tên phí</th>
                            <th className="text-right">Số tiền</th>
                          </tr>
                        </thead>
                        <tbody>{listItem()}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
